import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';
import { formatCurrency } from 'utils/NumberHelper';
import { DebtorHistoryStatus, DebtorHistoryStatusRange } from 'enums/debtor-history-type';
import {
  CreditScoreTypeLetter,
  CreditScoreTypeName,
  CreditScoreType,
} from 'enums/debtor-credit-score-type';

import Address from './AddressModel';
import DebtorOutstanding from './DebtorOutstandingModel';
import OutstandingInvoice from './OutstandingInvoice';

const DebtorRecord = Record({
  id: 0,
  contactId: null,
  contactNumber: null,
  name: null,
  firstName: null,
  lastName: null,
  emailAddress: null,
  address: null,
  outstandingAmount: 0,
  outstandingAmountMonthlyAverage: 0,
  outstandingInvoicesCount: 0,
  outstandingMonthlyAmounts: [],
  outstandingInvoices: [],
  creditScore: null,
  debtorDays: 0,
  revenue: 0,
});

export default class Debtor extends DebtorRecord {
  static deserialize(jsonObject = {}) {
    const mapProperties = {
      address: Address.deserialize,
      outstandingMonthlyAmounts: Hydrator.fromArray(DebtorOutstanding.deserialize),
      outstandingInvoices: Hydrator.fromArray(OutstandingInvoice.deserialize),
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    // TODO: retrieve score from credit reports when implemented
    const randomScore = Math.floor(Math.random() * 6).toString();
    const creditScoreKey = Object.keys(CreditScoreType).find(
      (scoreKey) => CreditScoreType[scoreKey] === randomScore,
    );

    hydrated.creditScore = CreditScoreType[creditScoreKey];

    return new Debtor(hydrated);
  }

  get outstandingLabel() {
    return `${formatCurrency(Math.abs(this.outstandingAmount))} outstanding`;
  }

  get daysLabel() {
    switch (this.daysStatus) {
      case DebtorHistoryStatus.normal:
        return '< 30 DAYS';
      case DebtorHistoryStatus.warning:
        return `${this.debtorDays} DAYS`;
      default:
        return 'No history';
    }
  }

  get daysStatus() {
    if (!this.debtorDays) return null;
    return this.debtorDays <= DebtorHistoryStatusRange.normal
      ? DebtorHistoryStatus.normal
      : DebtorHistoryStatus.warning;
  }

  get scoreRank() {
    return CreditScoreTypeLetter[this.creditScore] || '?';
  }

  get scoreLabel() {
    return CreditScoreTypeName[this.creditScore] || 'score';
  }
}
